import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index";
import ScrollToTop from "./components/ScrollToTop";

// Rota principal (Index) carrega eager; as demais são code-split por rota.
const QuemSomos = lazy(() => import("./pages/QuemSomos"));
const Solucoes = lazy(() => import("./pages/Solucoes"));
const Produtos = lazy(() => import("./pages/Produtos"));
const Segmentos = lazy(() => import("./pages/Segmentos"));
const SegmentoLP = lazy(() => import("./pages/SegmentoLP"));
const FAQ = lazy(() => import("./pages/FAQ"));
const Contato = lazy(() => import("./pages/Contato"));
const NotFound = lazy(() => import("./pages/NotFound"));

const App = () => (
  <TooltipProvider>
    <Toaster />
    <Sonner />
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/quem-somos" element={<QuemSomos />} />
          <Route path="/solucoes" element={<Solucoes />} />
          <Route path="/produtos" element={<Produtos />} />
          <Route path="/segmentos" element={<Segmentos />} />
          <Route path="/segmentos/:slug" element={<SegmentoLP />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contato" element={<Contato />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  </TooltipProvider>
);

export default App;
